import { AxiosResponse } from "axios";
import { request } from "~/utils/request";
import { GET_ALL_COMPANIES_API, GET_ALL_INDUSTRIES_API, GET_FILTER_OPTIONS_API } from "../routes";
import { SolrFilterParams, SolrSearchType } from "~/types/search.types";
import { ResCompanyData, ResFilters, ResIndustryData } from "~/types/filters.types";

/**
 * Fetches all companies and their data for reference
 * @returns ResAllCompanies
 */
export const fetchCompanies = (): Promise<AxiosResponse<ResCompanyData[], any>> => {
    return request({
        url: GET_ALL_COMPANIES_API,
        method: "GET"
    });
};

/**
 * Fetches all industries and their data for reference
 * @returns ResAllIndustries
 */
export const fetchIndustries = (): Promise<AxiosResponse<ResIndustryData[], any>> => {
    return request({
        url: GET_ALL_INDUSTRIES_API,
        method: "GET"
    });
};

/**
 * Fetches year, industry and company filters that have available results
 * @returns ResFilters
 */
export const fetchDynamicFilters = (
    data: SolrFilterParams,
    searchType: SolrSearchType
): Promise<AxiosResponse<ResFilters, any>> => {
    const region = import.meta.env.VITE_REGION;
    const api_route = GET_FILTER_OPTIONS_API(searchType, region);

    return request({
        url: api_route,
        data,
        method: "POST"
    });
};
